import React, { useState } from 'react'
import NavigationBar from '../Components/NavigationBar'
import SideBar from '../Components/SideBar'
import styled from 'styled-components'
import { useAuth } from '../Context/Auth'

const MainTab = styled.main`
  width: 100%;
  height: calc(100vh - 111px);
  // width: calc(100vw - 241px);
  margin-left: 222px;
  background-color: #FAFAFF;
  overflow: auto;
`

const PageLayout = props => {
  const { children } = props
  const { currentUser } = useAuth()
  const [isSidebarExpanded, setSidebarExpanded] = useState(true)
  const [isAvatarClicked, setAvatarClicked] = useState(false)
  const toggleSideBar = () => setSidebarExpanded(!isSidebarExpanded)
  return currentUser
    ? <>
      <NavigationBar
        toggleSideBar={toggleSideBar}
        isAvatarClicked={isAvatarClicked}
        setAvatarClicked={setAvatarClicked}
      />
      <div style={{ display: 'flex', backgroundColor: '#FAFAFF' }} onClick={() => setAvatarClicked(false)}>
        <SideBar expanded={isSidebarExpanded} />
        <MainTab>{children}</MainTab>
      </div>
    </>
    : children
}

export default PageLayout
